import React from "react";

export const SharedWithMeIcon = ({ stroke = "#113357" }: { stroke?: string }) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.66667 4.83333C4.66667 5.71739 5.01786 6.56523 5.64298 7.19036C6.2681 7.81548 7.11595 8.16667 8 8.16667C8.88406 8.16667 9.7319 7.81548 10.357 7.19036C10.9821 6.56523 11.3333 5.71739 11.3333 4.83333C11.3333 3.94928 10.9821 3.10143 10.357 2.47631C9.7319 1.85119 8.88406 1.5 8 1.5C7.11595 1.5 6.2681 1.85119 5.64298 2.47631C5.01786 3.10143 4.66667 3.94928 4.66667 4.83333Z"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 16.5V14.8333C3 13.9493 3.35119 13.1014 3.97631 12.4763C4.60143 11.8512 5.44928 11.5 6.33333 11.5H8.83333"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.857 12.4763C12.2319 11.8512 11.3841 11.5 10.5 11.5H8"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 13.1667L11.3333 17.3333"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3333 15.1111L11.3333 17.3333L13.5556 17.3333"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
